import DoneIcon from '@mui/icons-material/Done';
import { Box, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import KenTextField from '../KenTextField';
import KenTextLabel from '../KenTextLabel';

const useStyles = makeStyles({
  errorStyles: {
    backgroundColor: '#ffffff',
  },
  successMessage: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#158467',
  },
});

export default function KenInput(props) {
  const { label, required, optionalLabel, error, ui, success, disableKeyDown, hideLabel = false, helperText, minDate, disabled, ...otherProps } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Box width="100%">
        <Box component={'div'} className="d-flex flex-column" gap={'12px'}>
          {(!hideLabel && !isMobileScreen) && <KenTextLabel label={label} required={required} optionalLabel={optionalLabel} labelClassName={props.labelClassName} helperText={helperText} />}
          <KenTextField disableKeyDown={disableKeyDown} error={error} disabled={disabled} minDate={minDate} {...otherProps} label={label} />
        </Box>
        {success && (
          <Box display="flex" alignItems="flex-start" pt={1}>
            <Typography component="span">{success.icon || <DoneIcon fontSize="small" style={{ color: '#158467' }} />}</Typography>
            <Typography component="span" className={classes.successMessage} pl={1}>
              {success.message}
            </Typography>
          </Box>
        )}
      </Box>
      {ui && ui?.divider && (
        <Box mt={2} mb={2}>
          <Divider />
        </Box>
      )}
    </>
  );
}
